import { allPieces } from "@/utils/data"
import classNames from "classnames"
import dummyFlag from "@/images/boards/dummy-flag.png"
import Money from "@/Components/Money"
import { gameRoles } from "@/utils/gameRoles"
import { getPlayerAvatar } from "@/utils/playerAvatar"

export interface PlayerInfoSmallProps {
  player: IPlayer
  user: IUser
}
const tempUserImage =
  "https://plus.unsplash.com/premium_photo-1671656349322-41de944d259b?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"
const PlayerInfoSmall: React.FC<PlayerInfoSmallProps> = ({ player, user }) => {
  const piece = allPieces.find((item) => item.id === player.pieceId)
  const avatar = getPlayerAvatar(player, user)
  return (
    <div
      className={classNames(
        "flex justify-between items-center py-2 px-2.5 bg-black/30 w-full shadow-2xl",
        {}
      )}
      data-testid={`game.player-tab-${player.order}`}
    >
      <div className="flex gap-1.5 items-center">
        <img src={piece?.imgSrc} className="h-8 w-8"></img>
        <div className="flex gap-1.5 items-center">
          <img
            className="h-8 w-8 rounded-full object-cover"
            src={user?.profileImage || avatar || tempUserImage}
          ></img>
          <div className="flex flex-col gap-1">
            <div className="font-poppins text-white text-sm leading-tight">
              {user.username}
            </div>
            {player.role !== "none" && (
              <div
                className="px-1.5 py-0.5 flex rounded-md text-[10px] font-medium font-poppins h-fit whitespace-nowrap"
                style={{
                  backgroundColor:
                    gameRoles.find((r) => r.id === player.role)?.color + "40",
                  color: gameRoles.find((r) => r.id === player.role)?.color,
                }}
              >
                {gameRoles.find((r) => r.id === player.role)?.title}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlayerInfoSmall
